var API_CONFIG = {
    // URL base de la API - se puede sobrescribir con variable de entorno
    // En desarrollo, usar ruta relativa para aprovechar el proxy de Vue
    // En producción, usar la URL completa del servidor
    BASE_URL: '/gestioncomercial/api', // Usar ruta relativa para el proxy
    // Timeout para las peticiones (en milisegundos)
    TIMEOUT: 10000,
    // Headers por defecto
    DEFAULT_HEADERS: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
};
// Log de configuración en desarrollo
if (process.env.NODE_ENV === 'development') {
    console.log('🔧 Configuración de API:', {
        BASE_URL: API_CONFIG.BASE_URL,
        TIMEOUT: API_CONFIG.TIMEOUT,
        NODE_ENV: process.env.NODE_ENV
    });
}
export default API_CONFIG;
